import { createAsyncThunk } from "@reduxjs/toolkit"
import { formDataPost, get, post } from "helpers/api_helper"
import {
  CHANGE_PASSWORD,
  FORGOT_PASSWORD,
  GET_PROFILE_DETAILS,
  LOGIN_URL,
  OTP_VERIFICATION,
  RESEND_VERIFY_OTP,
  RESET_PASSWORD,
  UPDATE_BANK_DETAILS,
  UPDATE_GENERAL_DETAILS,
  UPDATE_JOB_APPLICATION_DETAILS,
  UPLOAD_PROFILE_DOCUMENT,
  VERIFY_AND_LOGIN,
  ASSETS_DELIVERY_CONFIRMATION,
} from "helpers/url_helper"

export const login = createAsyncThunk(LOGIN_URL, async payload => {
  const response = await post(LOGIN_URL, payload)
  return response
})

export const forgotPassword = createAsyncThunk(
  FORGOT_PASSWORD,
  async payload => {
    const response = await post(FORGOT_PASSWORD, payload)
    return response
  }
)

export const otpVerification = createAsyncThunk(
  OTP_VERIFICATION,
  async payload => {
    const response = await post(OTP_VERIFICATION, payload)
    return response
  }
)

export const changePassword = createAsyncThunk(
  CHANGE_PASSWORD,
  async payload => {
    const response = await post(CHANGE_PASSWORD, payload)
    return response
  }
)

export const getProfileDetails = createAsyncThunk(
  GET_PROFILE_DETAILS,
  async uuid => {
    const response = await get(`${GET_PROFILE_DETAILS}/${uuid}`)
    return response
  }
)

export const updateGeneralDetails = createAsyncThunk(
  UPDATE_GENERAL_DETAILS,
  async data => {
    const { uuid, payload } = data
    const response = await post(`${UPDATE_GENERAL_DETAILS}/${uuid}`, payload)
    return response
  }
)

export const updateBankDetails = createAsyncThunk(
  UPDATE_BANK_DETAILS,
  async data => {
    const { uuid, payload } = data
    console.log(uuid, payload)
    const response = await post(`${UPDATE_BANK_DETAILS}/${uuid}`, payload)
    return response
  }
)

export const updateJobApplicationDetails = createAsyncThunk(
  UPDATE_JOB_APPLICATION_DETAILS,
  async data => {
    const { uuid, payload } = data
    const response = await post(
      `${UPDATE_JOB_APPLICATION_DETAILS}/${uuid}`,
      payload
    )
    return response
  }
)

export const updateProfileDocument = createAsyncThunk(
  UPLOAD_PROFILE_DOCUMENT,
  async data => {
    const { uuid, payload } = data
    const response = await formDataPost(
      `${UPLOAD_PROFILE_DOCUMENT}/${uuid}`,
      payload
    )
    return response
  }
)

export const verifyAndLogin = createAsyncThunk(
  VERIFY_AND_LOGIN,
  async payload => {
    const response = await post(VERIFY_AND_LOGIN, payload)
    return response
  }
)

export const resendVerifyOtp = createAsyncThunk(
  RESEND_VERIFY_OTP,
  async payload => {
    const response = await post(RESEND_VERIFY_OTP, payload)
    return response
  }
)

export const resetPassword = createAsyncThunk(RESET_PASSWORD, async payload => {
  const response = await post(RESET_PASSWORD, payload)
  return response
})

export const assetsDeliveryConfirmation = createAsyncThunk(
  ASSETS_DELIVERY_CONFIRMATION,
  async payload => {
    const response = await post(ASSETS_DELIVERY_CONFIRMATION, payload)
    return response
  }
)